import React, { useState } from 'react';
import { Button } from './ui/button';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { LANGUAGES, CECRL_LEVELS } from '../constants/projectData';

const LanguageSelector = ({ languages, onChange }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [selectedLevel, setSelectedLevel] = useState('B2');

  const handleAdd = () => {
    if (!selectedLanguage) {
      toast.error('Please select a language');
      return;
    }
    
    // Check if language already exists
    if (languages.some(l => l.language === selectedLanguage)) {
      toast.error('Language already added');
      return;
    }

    onChange([...languages, { language: selectedLanguage, level: selectedLevel }]);
    setSelectedLanguage('');
    setSelectedLevel('B2');
  };

  const handleRemove = (index) => {
    onChange(languages.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-3">
      {/* Add language form */}
      <div className="flex gap-2">
        <div className="flex-1">
          <select
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value)}
          >
            <option value="">Select language...</option>
            {LANGUAGES.map(lang => (
              <option key={lang} value={lang}>{lang}</option>
            ))}
          </select>
        </div>
        <div className="w-48">
          <select
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            value={selectedLevel}
            onChange={(e) => setSelectedLevel(e.target.value)}
          >
            {CECRL_LEVELS.map(level => (
              <option key={level.value} value={level.value}>{level.label}</option>
            ))}
          </select>
        </div>
        <Button
          type="button"
          onClick={handleAdd}
          size="sm"
        >
          <Plus className="w-4 h-4" />
        </Button>
      </div>

      {/* Selected languages list */}
      {languages.length > 0 && (
        <div className="border border-gray-200 rounded-md p-3 bg-gray-50 space-y-2">
          {languages.map((lang, index) => (
            <div
              key={index}
              className="flex items-center justify-between bg-white px-3 py-2 rounded border border-gray-200"
            >
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900">{lang.language}</span>
                <span className="px-2 py-0.5 text-xs rounded bg-green-100 text-green-700">
                  {lang.level}
                </span>
              </div>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => handleRemove(index)}
                className="text-red-500 hover:text-red-700"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
